import styled from "styled-components/macro";
import { Side } from "./side";

interface SideMenuProps {
    side: Side;
}

export const SideMenuContainer = styled.div<SideMenuProps>`
    position: absolute;
    display: flex;
    flex-flow: row nowrap;
    top: 0;
    z-index: 3;
    right: ${(props: any) => (props.side === Side.Right ? 0 : undefined)};
    height: 100%;
    pointer-events: none;
    will-change: width;
`;
